import {
  connectRefinementList,
  Highlight
} from "react-instantsearch-dom";

import { useDispatch, useSelector } from "react-redux";

import {  slideDown, slideToggle, slideUp } from "@/helpers/userHelpers";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/compat/router";
import { setSelectedFilter } from "@/redux/actions/filtersAction";
import FilterNavWrapper from "./FilterNavWrapper";
import styles from "../FiltersComp/Filter.module.scss";
import {orderBy} from 'lodash';
import { PLPFiltersTracking } from "@/components/common/Tracking";

const types = {
  'jewelry-watches': 'Jewelry & watches',
  'home-gifts': 'Home & gifts',
  'bags-accessories': 'Bags & accessories'
}

const categories = {
  "bath-body": "Bath & body",
  "lingerie-sleepwear": "Lingerie & sleepwear",
  "coats-jackets": "Coats & jackets",
  "dining-entertaining": "Dining & entertaining",
  "socks-tights": "Socks & tights",
  "tools-accessories": "Tools & accessories",
  "gloves-scarves": "Gloves & scarves",
  "wallets-cardholders": "Wallets & cardholders",
  "jumpsuits-rompers":"Jumpsuits & rompers",
  "watch-winders":"Watch winders",
};

const subCategoies = {
  'joggers-sweatpants': 'Joggers & sweatpants',
  'puffer-quilted': 'Puffer & quilted',
  'sweatshirt-hoodies': 'Sweatshirt & hoodies',
  'chains-strands': 'Chains & strands',
  'mules-slides' : 'Mules & slides',
  'moisturizer-creams' : 'Moisturizer & creams',
  'hoops-huggies': 'Hoops & huggies',
  'bras-panties': 'Bras & panties',
  'loafers-oxfords': 'Loafers & oxfords',
  'crossbody-shoulder': 'Crossbody & shoulder',
  'Bangles-cuffs' : 'Bangles & cuffs',
  'puffer-quilted':'Puffer & quilted',
  'double-breasted': 'Double-breasted',
  'sweatshirt-hoodies': 'Sweatshirt & hoodies',
  'Decorative-pillows-throws': 'Decorative pillows & throws',
  'table-linens-accessories': 'Table linens & accessories',
  'candles-home-fragrances': 'Candles & home fragrances',
  'hair-masks-treatments':'Hair masks & treatments',
  'office-desk-accessories': 'Office & desk accessories',
  "one-piece":"One-Piece",
  "cover-ups":"Cover-Ups",
  "skinny-leg": "Skinny leg",
  "straight-leg": "Straight leg",
  "wide-leg": "Wide leg",
  "tank-cami": "Tank & cami",
  "knee-high": "Knee-high",
  "over-the-knee": "Over-the-knee",
  "cat-eye":"Cat-eye",
  "cleanser-exfoliant":"Cleanser & exfoliant",
  "bar-wine-accessories":"Bar & wine accessories",
  "bowls-trays":"Bowls & trays",
  "knee-high-boots": "Knee-high Boots",
  "demi-fine-jewelry": "Demi-fine jewelry",
  "demi-fine-earrings": "Demi-fine earrings",
  "demi-fine-necklaces": "Demi-fine necklaces",
  "demi-fine-rings": "Demi-fine rings",
  "demi-fine-bracelets": "Demi-fine bracelets",
  "demi-fine-anklets": "Demi-fine anklets"
}


const RefinementList = ({
  items,
  isFromSearch,
  refine,
  searchable,
  level,
  dispatch,
  selectedFilters,
  nav_cat,
  nav_type,
  nav_subcat,lableFilter,classActive,filterType,type,category,subcategory, router }) => {

  let itemArray = [];
  items.map((item) => {
    let items_res = item.label.split(' > ');
    if (items_res && items_res.length) {
      itemArray[item.label] = items_res[items_res.length - 1]
    } else {
      itemArray[item.label] = item.label;
    }
  })
  if (items.length == 0) return false
  const handleInputClick = (e, value, isRefined, valueForClear) => {

    let pathnameRouter = router.pathname
    if(pathnameRouter === "/[...pages]") {
      pathnameRouter = router.query.pages.join('/')
    }

    sessionStorage.setItem(`${pathnameRouter}~${level}`, value.toString())
    let updateSubcat;
    if(isRefined && level === 'type') {

      sessionStorage.setItem(`${pathnameRouter}~category`, '')
      sessionStorage.setItem(`${pathnameRouter}~subcategory`, '')
       
      if(sessionStorage.getItem(`${pathnameRouter}~type`) === value.toString()) {
        sessionStorage.setItem(`${pathnameRouter}~type`, '')
      }

      refine([])
      updateSubcat = {
        'type': '',
        'category': '',
        'subcategory': ''
      }
    } else {

      refine(value);
    }
    let target = e.currentTarget;
    let splitValue = '';
    if(value.toString().includes(' > ')) {

      let valArr = []
      value.forEach(val => {

        valArr.push(val.split(' > ').pop())
      })
      splitValue = valArr.join(', ')
    } else {
      splitValue = value.toString()
    }
    if(!splitValue && level === 'type') {

      updateSubcat = {
        'type' : '',
        'category' : '', 
        'subcategory' : ''
      }
    }
    dispatch(setSelectedFilter({
      ...selectedFilters,
      [level]: splitValue,
      ...updateSubcat
    }))

    /* START - PLP Filters Tracking */ 
    const updatedSelectedFilters = {
      ...selectedFilters,
      [level]: splitValue,
      ...updateSubcat
    } //using this manually as updated value is not available immediately in "selectedFilters"

    if(level && updatedSelectedFilters){
      let trackingValue = "";
      let valArray = [];
      const typeSelected = updatedSelectedFilters?.type;
      const categorySelected = updatedSelectedFilters?.category;
      const subcategorySelected = updatedSelectedFilters?.subcategory;

      if(isRefined && valueForClear && level === "type"){  //For uncheck filter - type
        trackingValue += valueForClear;
      }
      else if(typeSelected){
        trackingValue = typeSelected;
        if(isRefined && valueForClear && level === "category"){  //For uncheck filter - category
          trackingValue += " > "+valueForClear;
        }
        else if((level === "category" || level === "subcategory") && categorySelected){
          valArray = categorySelected.split(', ');
          valArray.sort((a, b) => a.localeCompare(b)); //sort alphabetically
          trackingValue += " > "+valArray.toString();

          if(isRefined && valueForClear){ //For uncheck filter - subcategory
            trackingValue += " > "+valueForClear;
          }
          else if(level === "subcategory" && subcategorySelected){
            valArray = subcategorySelected.split(', ');
            valArray.sort((a, b) => a.localeCompare(b)); //sort alphabetically
            trackingValue += " > "+valArray.toString();
          }
        }
      }
      if (trackingValue) {
        //If computed event label contains Category, subcategory replace string with Cat,Subcat
        PLPFiltersTracking(((level.charAt(0).toUpperCase() + level.slice(1)==="Category"&&"Cat")||(level.charAt(0).toUpperCase() + level.slice(1)==="Subcategory"&&"Subcat")||(level.charAt(0).toUpperCase() + level.slice(1)!=("Category"||"Subcategory"))), trackingValue, isRefined);
      }
    }
    /* END - PLP Filters Tracking */ 
    
    if(isRefined && level === 'type') {
      value = ''
    }
    if(value.toString()) {
      setTimeout(() => {
        
        let filterBody = target.closest('.filter_body')
        let parentSlide = target.closest('.filter_item')
        if(parentSlide?.classList.contains('collapse')) {
    
          parentSlide.classList.remove('active')
          slideUp(filterBody)
          let nextSlide = parentSlide.nextElementSibling
          if(nextSlide.classList.contains('search_hide')) {
            nextSlide = nextSlide.nextElementSibling
          }
          if(nextSlide?.classList.contains('filter_item')) {
            nextSlide.classList.add('active')
            let nextSlideBody = nextSlide.querySelector('.filter_body')
            slideDown(nextSlideBody)
          }
        }
      }, 500);
    }
  }
  return (
    <>
    <FilterNavWrapper 
    level={level}
    nav_type={nav_type}
    nav_cat={nav_cat}
    nav_subcat={nav_subcat}
    searchable={searchable}
    items={items}
    isFromSearch={isFromSearch}
    slideToggle={slideToggle}
    refine={refine}
    itemArray={itemArray}
    handleInputClick={handleInputClick}
    styles={styles}
    lableFilter={lableFilter}
    classActive={classActive}
    type={type}
    category={category}
    subcategory={subcategory}
    filterType={filterType}
    />
    </>
  )
};

const CustomRefinementList = connectRefinementList(RefinementList);

function handleType(type) {
  if(!type) return ''
  if(types[type]) return types[type]
  type = type.charAt(0).toUpperCase() + type.slice(1)
  return type
}

function handleSubCategories(subcategory) {
  if(!subcategory) return ''
  subcategory = subcategory.toLowerCase()
  subcategory = subcategory.split(',')
  subcategory.forEach((value, i) => {

    if(subCategoies[value]) {
      subcategory[i] = subCategoies[value]
    } else {

      let subValue = value.replaceAll('-', ' ').split(' ')
      let firstLetter = subValue[0].charAt(0).toUpperCase() + subValue[0].slice(1)
      subValue[0] = firstLetter
      subcategory[i] = subValue.join(' ')
    }
  })
  return subcategory.join(',')
}

function handleCategories(category) {
  if(!category) return ''
  category = category.toLowerCase()
  category = category.split(',')
  category.forEach((value, i) => {

    if(categories[value]) {
      category[i] = categories[value]
    } else {

      let subValue = value.replaceAll('-', ' ').split(' ')
      let firstLetter = subValue[0].charAt(0).toUpperCase() + subValue[0].slice(1)
      subValue[0] = firstLetter
      category[i] = subValue.join(' ')
    }
  })
  return category.join(',')
}

const FiltersNavComp = ({ styles,nav_cat,nav_type,nav_subcat }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  let type = nav_type ? nav_type : router.query.type;
  let category = nav_cat ? nav_cat : router.query.level; 
  let subcategory = nav_subcat ? nav_subcat : router.query.sublevel;
  const ISSERVER = typeof window === 'undefined'
  let typeLocal
  let levelLocal
  let sublevelLocal
  if(!ISSERVER) {

    let pathnameRouter = router.pathname
    if(pathnameRouter === "/[...pages]") {
      pathnameRouter = router.query.pages.join('/')
    }
    typeLocal = sessionStorage.getItem(`${pathnameRouter}~type`) || ''
    if(typeLocal) { 
      typeLocal = typeLocal.toString()
      type = typeLocal.toString() 
    }

    levelLocal = sessionStorage.getItem(`${pathnameRouter}~category`) || ''
    levelLocal = decodeURIComponent(levelLocal.toString())
    if(levelLocal) { 
      let splitedLevelValues = levelLocal.toString().split(',')
      splitedLevelValues.forEach((lvl, i) => {
        splitedLevelValues[i] = lvl.split(' > ').pop()
      })
      
      category = splitedLevelValues.join(',')
    }
    
    sublevelLocal = sessionStorage.getItem(`${pathnameRouter}~subcategory`) || ''
    sublevelLocal = decodeURIComponent(sublevelLocal.toString())
    if(sublevelLocal) { 
      let splitedSubLevelValues = sublevelLocal.split(',') 
      splitedSubLevelValues.forEach((lvl, i) => {
        splitedSubLevelValues[i] = lvl.split(' > ').pop()
      })
      subcategory = splitedSubLevelValues.join(',')
    }
  }


  type = handleType(type)
  category = handleCategories(category)
  subcategory = handleSubCategories(subcategory)
  const [hierarchicalMenuType, sethierarchicalMenuType] = useState('');
  const [hierarchicalMenCategory, sethierarchicalMenCategory] = useState('');
  const [hierarchicalMenSubcategory, sethierarchicalMenSubcategory] = useState('');
  const selectedFilters = useSelector((state) => state.filters);

  useEffect(() => {
    dispatch(setSelectedFilter({
      ...selectedFilters,
      'type': type || '',
      'category': category || '',
      'subcategory': subcategory || ''
    }))
    sethierarchicalMenuType([type])
    let pathnameRouter = router?.pathname
    if (type && category && subcategory) {
      let catArr = category.split(',');
      let catPush = [];
      let subcatPush = [];
      if(pathnameRouter === "/[...pages]") {
        pathnameRouter = router?.query?.pages.join('/')
      }
      if(catArr.length) {
        catArr.forEach((item, index) => {
          levelLocal && levelLocal.split(',').forEach(val => val && catPush.push(val))
          if(catPush.indexOf(type + ' > ' + item ) === -1) {

            catPush.push(type + ' > ' + item);
          }
          let subcatArr = subcategory.split(',');
          if(subcatArr.length) {
            sublevelLocal && sublevelLocal.split(',').forEach(val => val && subcatPush.push(val))

            subcatArr.forEach((item1, index) => {
              if(subcatPush.indexOf(type + ' > ' + item + ' > ' + item1) === -1) {

                subcatPush.push(type + ' > ' + item + ' > ' + item1);
              }
            });
          }
        });
      }      
      let filteredCategoryArr = []
      let filteredSubCategoryArr = []
      catPush.forEach((values, index) => {

        if(levelLocal) {

          if(levelLocal.split(',').indexOf(values) !== -1 && filteredCategoryArr.indexOf(values) === -1) {
  
            filteredCategoryArr.push(values)
          }
        } else {
          if(filteredCategoryArr.indexOf(values) === -1) {
  
            filteredCategoryArr.push(values)
          }
        }
      })
      subcatPush.forEach((values, index) => {
        
        if(sublevelLocal) {

          if(sublevelLocal.split(',').indexOf(values) !== -1 && filteredSubCategoryArr.indexOf(values) === -1) {
  
            filteredSubCategoryArr.push(values)
          }
        } else {
          if(filteredSubCategoryArr.indexOf(values) === -1) {
  
            filteredSubCategoryArr.push(values)
          }
        }
      })

      if(filteredCategoryArr.length) {

        sessionStorage.setItem(`${pathnameRouter}~category`, filteredCategoryArr)
        sethierarchicalMenCategory(filteredCategoryArr)
      } else {
        sessionStorage.setItem(`${pathnameRouter}~category`, '')
        sethierarchicalMenCategory('')
      }
      
      if(filteredSubCategoryArr.length) {
        sessionStorage.setItem(`${pathnameRouter}~subcategory`, filteredSubCategoryArr)
        sethierarchicalMenSubcategory(filteredSubCategoryArr)
      } else {
        sessionStorage.setItem(`${pathnameRouter}~subcategory`, '')
        sethierarchicalMenSubcategory('')
      }
    }
    if (type && category && !subcategory) {
      let catArr = category.split(',');
      let catPush = [];
      if(catArr && catArr.length) {
        levelLocal && levelLocal.split(',').forEach(val => val && catPush.push(val))
        catArr.forEach((item, index) => {
          
          if(catPush.indexOf(type + ' > ' + item) === -1) {

            catPush.push(type + ' > ' + item);
          }
        });
      }
      let filteredCategoryArr = []
      catPush.forEach((values, index) => {

        if(levelLocal) {
          if(filteredCategoryArr.indexOf(values) === -1 && levelLocal.split(',').indexOf(values) !== -1) {

            filteredCategoryArr.push(values)
          }
        } else {

          if(filteredCategoryArr.indexOf(values) === -1) {
  
            filteredCategoryArr.push(values)
          }
        }
      })
      if(filteredCategoryArr.length) {
        sessionStorage.setItem( `${pathnameRouter}~category`, filteredCategoryArr)
        sethierarchicalMenCategory(filteredCategoryArr)
      } else {
        sessionStorage.setItem( `${pathnameRouter}~category`, '')
        sethierarchicalMenCategory('')
      }
    }
  }, [router.query])

  useEffect(() => {
    if(selectedFilters.type === '' && !type) {
      sethierarchicalMenuType('')
    }
    if (selectedFilters.type === '' && selectedFilters.category === '' && !category && !type) {
      sethierarchicalMenCategory('')
    }
    if(selectedFilters.type === '' && selectedFilters.category === '' && selectedFilters.subcategory === '' && !category && !type && !subcategory) {
      sethierarchicalMenSubcategory('')
    }
  }, [selectedFilters])

  let typeFilter = <CustomRefinementList limit={25} attribute="named_tags.categories.lvl0" 
  level="type" 
  dispatch={dispatch} 
  selectedFilters={selectedFilters} 
  nav_type={nav_type} 
  nav_cat={nav_cat} 
  nav_subcat={nav_subcat} 
  lableFilter={"Category"}
  classActive=""
  filterType="type"
  type={selectedFilters.type}
  category={selectedFilters.category}
  subcategory={selectedFilters.subcategory}
  defaultRefinement={hierarchicalMenuType || []} 
  router={router}
  transformItems={(items) =>
    orderBy(items, ['label', 'count'], ['asc', 'desc'])
  }
   />;
  let categoryFilter = <CustomRefinementList limit={25} attribute="named_tags.categories.lvl1" 
  level="category" 
  dispatch={dispatch} 
  selectedFilters={selectedFilters} 
  nav_type={nav_type} 
  nav_cat={nav_cat} 
  nav_subcat={nav_subcat} 
  lableFilter={ selectedFilters.type ? selectedFilters.type : `Category`}
  classActive={ selectedFilters.type && !selectedFilters.category && !selectedFilters.subcategory ? 'active': ''}
  filterType="level"
  type={selectedFilters.type}
  category={selectedFilters.category}
  subcategory={selectedFilters.subcategory}
  defaultRefinement={hierarchicalMenCategory ||[]}
  router={router}
  transformItems={(items) =>
    orderBy(items, [function(o) {return o.label.split(' > ').pop().toString()}])
  }
  />;
  let subcategoryFilter = <CustomRefinementList limit={25} attribute="named_tags.categories.lvl2" 
  level="subcategory" 
  dispatch={dispatch} 
  selectedFilters={selectedFilters} 
  nav_type={nav_type} 
  nav_cat={nav_cat} 
  nav_subcat={nav_subcat} 
  lableFilter={ selectedFilters.category ? selectedFilters.category : `Category`}
  classActive={ selectedFilters.type && selectedFilters.category ? 'active' : ''}
  filterType="sublevel"
  type={selectedFilters.type}
  category={selectedFilters.category}
  subcategory={selectedFilters.subcategory}
  defaultRefinement={hierarchicalMenSubcategory || []} 
  router={router}
  transformItems={(items) =>
    orderBy(items, [function(o) {return o.label.split(' > ').pop().toString()}])
  }
  />;
  return (
    <>
      {/* Type Section */}
      {typeFilter && typeFilter}

      {/* End of Type Section */}

      {/* Category Section */}
      {categoryFilter && selectedFilters.type && categoryFilter}
      {/* End of Category Section */}

      {/* Subcategory Section */}
      {subcategoryFilter && selectedFilters.type && selectedFilters.category && subcategoryFilter}
      {/* End of Subcategory Section */}
    </>
  );
};

export default FiltersNavComp
